module.exports = __webpack_public_path__ + "static/images/two-arrows-circle-background.aa7748f818a15828676d54e716c40694.svg";